export default class Score {
  constructor (data) {
    this.points = data.points
    this.questions = data.questions

    Object.freeze(this)
  }
}
